export default __webpack_public_path__ + "static/media/infiniumsplash.adfc590f.png";